<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Penalty Type
    </button>

    <a-modal v-model="visible" title="Add Penalty Type">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
            Add Penalty Type
        </a-button>
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: 'Please enter name' }] },
            ]"
          />
        </a-form-item>

        <a-form-item label="Description">
          <a-input v-decorator="['description']" />
        </a-form-item>

        <a-form-item label="Severity">
            <a-select v-decorator="['severity', {initialValue: 'Minor', rules: [{ required: true, message: 'Please select severity' }] }]">
                <a-select-option value="minor">Minor</a-select-option>
                <a-select-option value="medium">Medium</a-select-option>
                <a-select-option value="major">Major</a-select-option
            >
            </a-select>
        </a-form-item>

        <a-form-item label="Active">
          <a-checkbox v-decorator="['active', { valuePropName: 'checked', initialValue: true }]">
            Active
          </a-checkbox>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>

export default {
  name: 'AddPenaltyType',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },
    handleSubmit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Add "${values.name}" penalty?`,
            content: 'Click OK to confirm.',
            onOk: () => {
              this.$http
                .post('/api/discipline-penalty', {
                  name: values.name,
                  description: values.description,
                  severity: values.severity,
                  active: values.active ? 1 : 0,
                })
                .then(({ data }) => {
                  this.loading = false
                  this.visible = false
                  this.$emit('created')
                  this.$notification.success({
                    message: 'Penalty Type Added',
                    description: `${data.name} added successfully.`,
                  })
                  this.form.resetFields()
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        } else {
          this.loading = false
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>
